import { H3 } from '@ui-library/typography';
import ConfiguredData from '@components/sources/source/warehouseSource/configureData';
import VisualMapping from '@components/sources/visualizer/mappingScreens/visualMapping';
import React, { FunctionComponent } from 'react';
import { IDestination } from '@stores/destination';
import {
  getMapperInfo,
  isMappedToDestination,
  mappingType,
} from '@components/sources/visualizer/mappingScreens/schemaEditor';
import { ISource, ISourceStore } from '@stores/source';
import { ErrorProps } from '@components/sources/visualizer/mappingScreens/errorsView';
import useStores from '@stores/useStores';
import classes from './sync-schema.module.scss';
import { Skeleton } from 'antd';
import { observer } from 'mobx-react';

interface ISchemaViewProps {
  destination: Partial<IDestination>;
  source?: ISourceStore;
  setMappingTypeValue?: (mappingTypeVal: string) => void;
  setBottomEditButtonVisible?: (show: boolean) => void;
  updateSchemaErrors: (errorsItems: ErrorProps[]) => void;
}

type SchemaViewProps = ISchemaViewProps;
const SchemaView: FunctionComponent<SchemaViewProps> = (props: SchemaViewProps) => {
  const {
    source,
    destination,
    setMappingTypeValue,
    setBottomEditButtonVisible,
    updateSchemaErrors,
  } = props;
  const config = source?.config;
  const { modelListStore } = useStores();
  const mappedToDestination = isMappedToDestination(config?.constants || []);
  if (setMappingTypeValue) {
    setMappingTypeValue(
      mappedToDestination ? mappingType.newMappingSelected : mappingType.oldMappingSelected,
    );
  }
  if (!source?.config.accountId && !source?.config.rudderAccountId && !modelListStore.firstLoad) {
    return <Skeleton active />;
  }
  return (
    <div className={classes.configure_data_wrapper}>
      <div className={classes.configured_data_header}>
        <H3>
          Configured Data
          {source?.sourceDef && getMapperInfo(source.sourceDef, Boolean(mappedToDestination))}
        </H3>
      </div>
      {!mappedToDestination ? (
        <ConfiguredData
          defaultValue={{
            schema: config?.query?.table?.schema,
            table: config?.query?.table?.name,
            columns: config?.query?.columns,
            mapping: config?.mappings?.map((curr) => ({ ...curr, mappedArray: [curr.mapped] })),
            prefix: config?.prefix,
            bucketName: config?.bucketName,
            overridesConfig: config?.map_important_overrides,
            constants: config?.constants,
            syncBehaviour: config?.syncBehaviour,
            sqlModelId: modelListStore.sourceModelMap[source?.id || ''],
          }}
          destSyncBehaviourOptions={destination.destinationDefinition?.config?.syncBehaviours}
          schedule={config?.schedule}
          sourceDefinition={source?.sourceDef}
          accountId={config?.accountId || config?.rudderAccountId || ''}
          onChange={() => null}
          ifUpdate={false}
          viewOnly
          updateSchemaErrors={updateSchemaErrors}
        />
      ) : (
        <VisualMapping
          sourceSettings={{
            ...config,
            sqlModelId: modelListStore.sourceModelMap[source?.id || ''],
            accountId: config?.rudderAccountId || config?.accountId,
          }}
          source={source as ISource}
          destination={destination}
          ifUpdate={false}
          viewOnly
          setBottomEditButtonVisible={setBottomEditButtonVisible}
          updateSchemaErrors={updateSchemaErrors}
        />
      )}
    </div>
  );
};

export default observer(SchemaView);
